export default {
  lineOptions: {
    yes: 'Oui',
    no: 'Non',
  },
  indicators: {
    initialValue: "Valeur Initiale: {initialValue}",
  }
}
export const globalI18nRoot = 'global'
